import {
  EMPLOYEE_CHANGE_FETCHING,
  EMPLOYEE_CHANGE_SUCCESS,
  EMPLOYEE_CHANGE_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_CHANGE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEE_CHANGE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEE_CHANGE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
